import * as React from 'react'
import { useIntl } from 'react-intl'
import PriceDetails, { buildDaysPriceLabel } from './PriceDetails'
import useTourV2PurchasableOptionDetails from 'hooks/TourV2/useTourV2PurchasableOptionDetails'
import { useAppSelector } from 'hooks/reduxHooks'
import { getCanViewLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'

interface CardProps {
  purchasableOption: App.Tours.TourV2OfferPurchasableOption
  duration: number | null
  depositComponent: React.ReactNode
  currencyCode: string
  discountDisplayType?: React.ComponentProps<
    typeof PriceDetails
  >['discountDisplayType']
}

function TourV2OfferCardPriceDetails({
  purchasableOption,
  duration,
  depositComponent,
  currencyCode,
  discountDisplayType = 'following',
}: CardProps) {
  const intl = useIntl()
  const purchasableOptionDetails =
    useTourV2PurchasableOptionDetails(purchasableOption)
  const isLuxPlusMember = useAppSelector(getCanViewLuxPlusBenefits)
  if (!duration || !purchasableOptionDetails) return null
  return (
    <PriceDetails
      price={purchasableOptionDetails.pricePerPerson}
      luxPlusPrice={purchasableOptionDetails.memberPricePerPerson}
      value={purchasableOptionDetails.valuedAt?.price}
      discount={isLuxPlusMember ? purchasableOptionDetails.valuedAt?.memberSavingsPercentage : purchasableOptionDetails.valuedAt?.savingPercentage}
      currencyCode={currencyCode}
      priceLabel={buildDaysPriceLabel(intl, duration, duration)}
      totalLabel="/person"
      discountDisplayType={
        purchasableOptionDetails.hasDiscount ? discountDisplayType : 'none'
      }
      roomOccupancy={purchasableOptionDetails.roomTypeName ?? undefined}
      depositComponent={depositComponent}
    />
  )
}

export default TourV2OfferCardPriceDetails
